export const EVENT_LABELS: Record<string, string> = {
  request_created: 'Anfrage erstellt',
  wave_started: 'Kontaktrunde gestartet',
  teacher_contacted: 'Lehrer kontaktiert',
  response_received: 'Antwort erhalten',
  acceptance: 'Zusage',
  decline: 'Absage',
  wave_completed: 'Kontaktrunde abgeschlossen',
  request_filled: 'Anfrage besetzt',
  request_failed: 'Anfrage fehlgeschlagen',
  pool_resolved: 'Wartepool aufgelöst',
  next_wave_triggered: 'Nächste Kontaktrunde gestartet',
  admin_intervention: 'Admin-Eingriff',
  request_cancelled: 'Anfrage storniert',
  request_expired: 'Anfrage abgelaufen',
  storno_initiated: 'Storno eingeleitet',
  storno_accepted: 'Storno bestätigt',
  storno_declined: 'Storno abgelehnt',
  storno_expired: 'Storno abgelaufen',
  admin_assigned: 'Admin zugewiesen',
  admin_cancelled: 'Admin storniert',
  lesson_released: 'Lektion zurück in den Stundenplan',
};

export function getEventLabel(eventType: string): string {
  return EVENT_LABELS[eventType] || eventType;
}

export function formatRelativeTime(isoString: string): string {
  const now = new Date();
  const eventTime = new Date(isoString);
  const diffMs = now.getTime() - eventTime.getTime();
  if (diffMs < 0) return 'gerade eben';
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return `vor ${diffSec}s`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `vor ${diffMin} Min.`;
  const diffHrs = Math.floor(diffMin / 60);
  if (diffHrs < 24) return `vor ${diffHrs}h`;
  const diffDays = Math.floor(diffHrs / 24);
  return `vor ${diffDays}d`;
}
